import PropertyDetailData from './PropertyDetailData';

export default PropertyDetailData;
